import {
    DEALERGETDEFAULTCURRENCYLISTDEALER_SUCCESS,
    DEALERGETDEFAULTCURRENCYLISTDEALER_FAILED,
    RESET_DEALERGETDEFAULTCURRENCYLISTDEALER,
    LOADING_DEALERGETDEFAULTCURRENCYLISTDEALER,
    NETWORK_ERROR_DEALERGETDEFAULTCURRENCYLISTDEALER
} from "../types/index"


const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {}
};


export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_DEALERGETDEFAULTCURRENCYLISTDEALER:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {}
            };
        case DEALERGETDEFAULTCURRENCYLISTDEALER_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload
            };
        case DEALERGETDEFAULTCURRENCYLISTDEALER_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload
            };
        case NETWORK_ERROR_DEALERGETDEFAULTCURRENCYLISTDEALER:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {}
            };
        case RESET_DEALERGETDEFAULTCURRENCYLISTDEALER:
            return (state = initialState);
        default:
            return state;
    }
};